import { EmptyState } from '../../../../shared/ui/empty-state/EmptyState';

export function NoResultsEmptyState() {
  return (
    <EmptyState
      title="No results found"
      subtitle="Try adjusting your search or filters"
      ariaLabel="No results found"
    />
  );
}
